import { RegularButton, Modal } from 'fronton-react'
import { FC } from "react";
import './modalClasses.scss'


export interface ModifyErrorModalProps {
    open: boolean,
    onClose: () => void,
}

export const ModifyErrorModal:FC<ModifyErrorModalProps> = ({open, onClose}) => {
    return (
        <Modal
        size="s"
        show={open}
        className="add-calendar-modal"
        closeButton={false}
        onClose={onClose}
        overlayType="medium"
    >
        <div className="modal-content">
            <div className="modal-content-body">
                Вы не можете изменять уже утвержденный календарь
            </div>
            <div className="modal-content-actions">
                <RegularButton
                    key="submit"
                    size="s"
                    variant="primary"
                    className="modal-content-btn"
                    onClick={onClose}
                >
                    ок
                </RegularButton>
            </div>
        </div>
    </Modal>

    )
}